import { Typography, TypographyProps } from "@/common/styles/style";
import { style } from "./style";

interface RequiredAsteriskProps {
  props?: TypographyProps;
}

export default function RequiredAsterisk({ props }: RequiredAsteriskProps) {
  return (
    <Typography variant="h6" sx={style} {...props}>
      *
    </Typography>
  );
}
